import React from "react";
import { colors } from "@mqd/volt-toolbox/src";
import PropTypes from "prop-types";
import { ICONS } from "./icons.js";
export function Icon({
  name,
  size,
  testId,
  factor,
  type,
  ...otherProps
}) {
  name = name || type;
  if (!name)
    return null;
  if (factor) {
    size = String(`${1.5 + (factor - 1) * 0.5}rem`);
  }
  if (testId) {
    otherProps["data-testid"] = testId;
  }
  if (!otherProps.color) {
    otherProps.color = {
      fill: colors.blackLighter4,
      stroke: colors.blackLighter4
    };
  }
  if (typeof otherProps.color === "string") {
    otherProps.color = {
      fill: otherProps.color,
      stroke: otherProps.color
    };
  }
  if (colors[otherProps.color.fill]) {
    otherProps.color.fill = colors[otherProps.color.fill];
  }
  if (colors[otherProps.color.stroke]) {
    otherProps.color.stroke = colors[otherProps.color.stroke];
  }
  const icon = ICONS[name];
  return /* @__PURE__ */ React.createElement(icon.svg, { width: size, height: size, ...otherProps });
}
Icon.propTypes = {
  className: PropTypes.string,
  factor: PropTypes.number,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  color: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      fill: PropTypes.string,
      stroke: PropTypes.string
    })
  ]),
  name: PropTypes.string,
  testId: PropTypes.string,
  type: PropTypes.string
};
Icon.defaultProps = {
  size: "1rem",
  color: {
    fill: colors.blackLighter4,
    stroke: colors.blackLighter4
  }
};
